function Politicas() {
    return (
        <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '80%', marginLeft: "auto", marginRight: 'auto' }}>
            <h1 style={{ textAlign: 'center' }}>Politicas de privacidad</h1>
            <p style={{ textAlign: 'center', fontWeight: "600", fontSize: 22 }}>La Ley de Protección de los Datos Personales (Ley N° 25.326) es una norma de orden público
                que regula la actividad de las bases de datos que registran información de carácter personal. Su
                objeto es garantizar a las personas el control del uso de sus datos personales.
            </p>
            <p style={{ textAlign: 'center', fontWeight: "600", fontSize: 22 }}>El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos
                en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés
                legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326.
            </p>
            <p style={{ textAlign: 'center', fontWeight: "600", fontSize: 22 }}>La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control
                de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan
                con relación al incumplimiento de las normas sobre protección de datos personales.</p>
        </div>
    )
}

export default Politicas